module.exports = __webpack_public_path__ + "static/assets/d4f362370d76c864bc6d4e608358f9a3.png";